import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'GRrejectreport',
	components: {
		BasicSelect,
		Pagination,
		JsonExcel,
		DatePicker,
		download,
		Loader
	},
	props: [],
	data() {
		return {
			selectedmerchant: { value: '', text: '' },
			merchantList: [],
			listMerchantIdData: [],
			merchantnameFlt: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalRows: 0,
			currentPage: 1,
			totalPage: 0,
			//totalCount:0,
			pageLimit: 10,
			// currentPage: 0,
			formattedDate: '',
			resultCount: '',
			ClientErr: '',
			WarehouseErr: '',
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			fromdate: '',
			todate: '',
			pono: '',
			drid: '',
			rejectreason: '',
			invreferenceid: '',
			productid: '',
			eancode: '',
			productname: '',
			ProductID: '',
			mrp: '',
			brand: '',
			rejectedquantity: '',
			reason: '',
			user_type: '',
			// perPage: 10,
			// pageno: 0,
			// pageCount: 0,
			isLoading: false,
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectMerchant: false,
			showSelectClient: false,
			csvFields: [],
			listGRRejectReportDataCsv: [],
			listGRRejectReportData: [],
			listClientData: [],
			listWarehouseData: [],
			userid: '',
			dataFilter2: '',
			reportname: '',
			show: false,
			download: true,
			isLoadingforxls: false,
			limitExeed: false,
			recordLimit: 0,
			mid: '',
			activemrpflag:false,

		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('editedjson.rejectReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client

		if(this.clientid!=='undefined'){
			this.getMerchantList();
         }

		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true
				// this.getWarehouseList();
				this.getMerchantList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid != null) {
					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		selectMerchant(data) {
			this.selectedmerchant = data;
			this.merchantnameFlt = data.value;
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.listMerchantData = result.data;
					this.merchantList.push({
						value: '', text: this.$t('common.selectMerchantPlaceHolder')
					}
					)
					for (var i = 0; i < this.listMerchantData.length; i++) {
						this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
						});
					}
				}, error => {
					console.error(error);
				})
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;

			if (!this.limitExeed) {
				this.getGRreportdataForXls(3)
			}
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client || this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();
		// 			// this.getGRreportdata();
		// 		}
		// 	}
		// 	this.listGRRejectReportData = [];
		// 	this.pageno = this.pageCount = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.pageCount = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getGRreportdata();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": this.clientid,
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		getGRreportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getGRreportdata(2);
		},
		getGRreportdata(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			// this.ClientErr = '';
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.pageCount = 0;
				this.listGRRejectReportData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.pageCount = 0;
				this.listGRRejectReportData = [];
				return false;
			}

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}

			// if (csvCheck != 1)
			// this.pageno = 0;
			this.isLoading = true;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				pono: this.pono.trim(),
				productid: this.ProductID.trim(),
				eancode: this.eancode.trim(),
				invreferenceid: this.invreferenceid.trim(),
				brand: this.brand.trim(),
				reason: this.reason.trim(),
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				merchantid: this.merchantnameFlt,
				userid: this.userid,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getGRRejectReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listGRRejectReportDataCsv = [];
							this.csvFields = {
								'pono': this.$t('inwardList.printData.po'),
								'invreferenceid':  this.$t('removeHold.drId'),
								'productid': this.$t('common.productId'),
								'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
								'productname': this.$t('printProductDetails.productName'),
								'mrp':  this.$t('removeHold.productMrp'),
								'activemrp':  this.$t('common.activemrp'),
								'brand': this.$t('common.brandName'),
								'reasontype':  this.$t('editedjson.reasonType'),
								'rejectedqty': this.$t('grcRejectReport.RejectedQty'),
								'reason': this.$t('receivedEmail.RejectReason'),
								'rejectedby': this.$t('grcRejectReport.rejectedby'),
								'rejecteddate': this.$t('grcRejectReport.rejectedDate'),
								'expirydate': this.$t('srqc.expiryDate'),
								'lotno': this.$t('moveOrderList.lotNo'),
								'merchantname':  this.$t('common.merchant'),


							};
							var dateFilter = [];
							if(this.activemrpflag === true){
								var skipFilter = ['count', 'merchantid'];
							}else {
								var skipFilter = ['count', 'merchantid','activemrp'];
							}
							this.listGRRejectReportDataCsv = result.data.data;

							csvHelper.data.jsonToCSV(this.$t('editedjson.rejectReport'), this.listGRRejectReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('GRRejectReport', this.listGRRejectReportDataCsv, this.csvFields, dateFilter, skipFilter);

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listGRRejectReportData = result.data.data;

						if (result.data.errorCode == -1) {
							this.totalRows = 0;
							this.resultCount = 0;
						} else {
							// this.totalRows = result.data.count;
							// this.resultCount = result.data.count;
							// if (this.totalRows <= this.perPage) {
							// 	this.pageCount = 1;
							// } else {
							// 	this.pageCount = Math.ceil(this.totalRows / this.perPage);
							// }
							this.totalRows = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count;
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getGRreportdataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}

			// if (csvCheck != 1)
			// this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				pono: this.pono.trim(),
				productid: this.ProductID.trim(),
				eancode: this.eancode.trim(),
				invreferenceid: this.invreferenceid.trim(),
				brand: this.brand.trim(),
				reason: this.reason.trim(),
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				merchantid: this.merchantnameFlt,
				userid: this.userid,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getGRRejectReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
							    this.csvFieldsForXls[this.$t('inwardList.printData.po')] ='pono';
								this.csvFieldsForXls[this.$t('removeHold.drId')] = 'invreferenceid';
								this.csvFieldsForXls[this.$t('product.productId')] = 'productid';
								this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
								this.csvFieldsForXls[this.$t('product.productName')] = 'productname';
								this.csvFieldsForXls[this.$t('removeHold.productMrp')] =  'mrp';
								if(this.activemrpflag === true){
									this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
								}
								this.csvFieldsForXls[this.$t('common.brandName')] = 'brand';
								this.csvFieldsForXls[this.$t('editedjson.reasonType')] = 'reasontype';
								this.csvFieldsForXls[this.$t('grcRejectReport.RejectedQty')] ='rejectedqty';
								this.csvFieldsForXls[this.$t('receivedEmail.RejectReason')] = 'reason';
								this.csvFieldsForXls[this.$t('grcRejectReport.rejectedby')] = 'rejectedby';
								this.csvFieldsForXls[this.$t('grcRejectReport.rejectedDate')] = 'rejecteddate';
								this.csvFieldsForXls[this.$t('common.merchant')] = 'merchantname';


							this.listReportDataforxls = result.data.data;


						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getGRreportdata();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getGRreportdata()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.merchantnameFlt = '';
			this.show = false;
			this.download = true;
			this.pono = '';
			this.ProductID = '';
			this.eancode = '',
				this.invreferenceid = '';
			this.brand = '';
			this.reason = '';
			this.fromdate = '';
			this.todate = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.GRRejectReport = '';
			this.searchFlag = false;
			this.listGRRejectReportData = [];
			this.selectedmerchant = {}
			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	// this.merchantList = []
			// }
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// 	// this.merchantList = []

			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/GRrejectreport/GRrejectreport.component.js